import React from 'react';
import { Button, Modal } from 'antd';
import { confirmCloseEditing, confirmCloseCreation } from '../popup/confirm';
const confirm = Modal.confirm;

const BtnCloseEditing = ({ handleClick, typeForm }) => {
  const confirmShow = () => {
    confirm({
      ...(typeForm === 'create' ? confirmCloseCreation : confirmCloseEditing),
      onOk: handleClick,
    });
  };

  return (
    <Button
      className="btn_danger-close"
      onClick={confirmShow}
      type="danger"
      ghost
      size="large"
    >
      Отмена
    </Button>
  );
};

export default BtnCloseEditing;
